import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { deleteGuestGroups, fetchGuestList } from '../../../actions/GuestActions';
import { hideModal } from '../../../actions/ModalActions';

class DeleteGuestGroupModal extends Component {

  getPrimaryGuest(guestGroup) {
    return _.find(guestGroup.guests, guest => guest.relationship_type === 'PRIMARY');
  }

  getNumGuests(guestGroupIds, guestGroupsById) {
    return _.reduce(guestGroupIds, (acc, id) => (
      acc + guestGroupsById[id].guests.length
    ), 0);
  }

  formatName(guest) {
    return `${guest.first_name} ${guest.family_name}`;
  }

  render() {
    const { onSubmit, onCancel, guestGroupsById, guestGroupIds } = this.props;
    const numToDelete = this.getNumGuests(guestGroupIds, guestGroupsById);
    return (
      <div>
        <div className="modal-header">
          <h3 className="modal-title">Delete</h3>
        </div>
        <div className="modal-body text-center">
          {guestGroupIds.length > 1 ? (
            <p>Are you sure you want to delete all <strong>{numToDelete}</strong> guests?</p>
          ) : (
            <p>Are you sure you want to delete <strong>{this.formatName(this.getPrimaryGuest(guestGroupsById[guestGroupIds[0]]))}</strong> and all guest information?</p>
          )}
          {window.zola.env !== 'production' &&
            <p>If any guest appears on a seating chart, they will be removed from it.</p>
          }
          <p>This cannot be undone</p>
          <ul className="list-inline">
            <li><a role="button" className="btn btn-primary" onClick={() => onSubmit(guestGroupIds)}>Delete</a></li>
            <li><a role="button" className="btn btn-secondary" onClick={onCancel}>Cancel</a></li>
          </ul>
        </div>
      </div>
    );
  }
}

DeleteGuestGroupModal.propTypes = {
  guestGroupsById: PropTypes.shape({}),
  guestGroupIds: PropTypes.arrayOf(PropTypes.number),
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  guestGroupsById: state.guestList.guests.byId
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (guestGroupIds) => {
    dispatch(deleteGuestGroups(guestGroupIds)).then(() => {
      dispatch(hideModal());
      dispatch(fetchGuestList());
    });
  },
  onCancel: () => dispatch(hideModal())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteGuestGroupModal);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/DeleteGuestGroupModal.jsx